// extracted by mini-css-extract-plugin
var _1 = "WireframeThumbnail_placeholder__lHZd5";
var _2 = "WireframeThumbnail_thumbnail__n38Wf";
export { _1 as "placeholder", _2 as "thumbnail" }
